<i18n>
{
  "en": {
    "hello": "Welcome to Verification System!"
  },
  "ja": {
    "hello": "手続きシステムへようこそ！"
  }
}
</i18n>

<template>
  <v-container>
    <Toolbar :title="campaign.name + $t('hello')" />
    <v-layout row wrap align-center justify-center pt-5>
      <v-flex text-xs-center xs12 sm12 md8 lg8>
        ログアウト
      </v-flex>
      <v-flex xs12 sm12 md12></v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Toolbar from '@/components/molecules/Toolbar.vue';
import { mapGetters, mapActions } from 'vuex';
import TokenManager from '@/utils/TokenManager';
import StorageManager from '@/utils/StorageManager';

export default {
  components: {
    Toolbar
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({ campaign: 'getCurrentCampaign' })
  },
  created() {
    TokenManager.remove();
    this.$router.push(
      `/cp/${StorageManager.getItem('CAMPAIGN_CODE_SESSION_KEY')}/login`
    );
  },
  methods: {
    ...mapActions(['prepareToSignin', 'login', 'setCurrentCampaign'])
  }
};
</script>
